import { TFunction } from 'i18next';
import React from 'react';
import { Table } from  '@bbri/ui';
import { RequirementResult } from '../../../models/RequirementResults';
import { FormService } from '../../../services/FormService';

interface Props {
  t: TFunction;
  formService: FormService;
  results: RequirementResult[];
  createRowResults: () => React.ReactNode;
}

export const FormResultTableResultView: React.FC<Props> = ({
  t,
  formService,
  createRowResults }) => {
  return (
    <Table id="table-results">
      <thead>
      <tr>
        <th style={ { width: "10%" } }></th>
        <th style={ { width: "30%" } }>
          { formService.t(t, "ui_requirement_results_requirement", true) }
        </th>
        <th style={ { width: "60%" } }>
          { formService.t(t, "ui_requirement_results_result", true) }
        </th>
      </tr>
      </thead>
      <tbody>{ createRowResults() }</tbody>
    </Table>
  );
}